export default __webpack_public_path__ + "static/media/MarneSneaker_Wide.bf7ebea0.jpg";